<template>
  <SimpleDataTable
      :title="'Top 10 Cari'"
      :description="''"
      :dataList="top10CurrentList"
      :dataHeaders="top10CurrentListHeaders"
      :loading="top10CurrentListLoading"
      :pagination-status="true"
      :pagination-length="totalPages"
      @page-change="handlePageChange"
  >
    <template v-slot:filterAndAction>
      <v-btn link color="primary" small to="current-list" target="_blank">Tüm Cariler</v-btn>
    </template>
  </SimpleDataTable>
</template>

<script>

import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import {mapActions, mapState} from "vuex";
import {numberConverter} from "../../../../helpers";

export default {
  name: "Top10Cari",
  components: {
    SimpleDataTable
  },
  props:{
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState("auth",["user"]),
    ...mapState("settings",["erpSettings"])

  },
  mounted() {
    this._fetchTop10CurrentList()
  },
  data(){
    return {
      currentPage: 1,
      totalPages: null,
      top10CurrentList :[],
      top10CurrentListHeaders: [],
      top10CurrentListLoading: false
    }
  },
  methods: {
    ...mapActions("dashboard",["fetchTop10CurrentList"]),
    numberConverter,
    async handlePageChange(newPage) {
      this.currentPage = newPage;
      await this._fetchTop10CurrentList();
    },
    _fetchTop10CurrentList(){
      this.fetchTop10CurrentList({
        params: {
          pageNumber: this.currentPage,
          pageSize: 10,
        },
        body: {
          dateType: 4,
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp},
        }
      }).then(result => {
        if(result && result.data.success)
        {
          this.top10CurrentListHeaders = this.erpSettings.netsisCurrencySale ? [
            {
              key: 'currentCode',
              label: 'Cari Kodu',
              sortable: false,
            },
            {
              key: 'currentName',
              label: 'Cari Adı',
              sortable: false,
            },
            {
              key: 'salesPersonCode',
              label: 'Plasiyer Kodu',
              sortable: false,
            },
            {
              key: 'salesPersonName',
              label: 'Plasiyer Adı',
              sortable: false,
            },
            {
              key: 'vatExcludedPrice',
              label: 'Satış Tutarı',
              sortable: false,
            },
            {
              key: 'vatExcludedCurrencyPrice',
              label: 'Dövizli Satış Tutarı',
              sortable: false,
            },
          ] : [
            {
              key: 'currentCode',
              label: 'Cari Kodu',
              sortable: false,
            },
            {
              key: 'currentName',
              label: 'Cari Adı',
              sortable: false,
            },
            {
              key: 'salesPersonCode',
              label: 'Plasiyer Kodu',
              sortable: false,
            },
            {
              key: 'salesPersonName',
              label: 'Plasiyer Adı',
              sortable: false,
            },
            {
              key: 'vatExcludedPrice',
              label: 'Satış Tutarı',
              sortable: false,
            },
          ];
          this.totalPages = result.data.totalPages;
          this.top10CurrentList = result.data.data;
          this.top10CurrentList.map(item => item.vatExcludedPrice = numberConverter(item.vatExcludedPrice))
          this.top10CurrentList.map(item => item.vatExcludedCurrencyPrice = numberConverter(item.vatExcludedCurrencyPrice))
        }
      })
    }
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal){
      newVal;
      this._fetchTop10CurrentList()
    },
    dashboardFilterSalesPersonCodeProp(newVal){
      newVal;
      this._fetchTop10CurrentList()
    },
    dashboardFilterReportDbNameProp(newVal){
      newVal;
      this._fetchTop10CurrentList()
    },
  }
}
</script>

<style scoped>

</style>